"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.period.lastWeek': 'Ostatni Tydzień',
    'reports.period.lastMonth': 'Ostatni Miesiąc',
    'reports.period.last3Months': 'Ostatnie 3 Miesiące',
    'reports.period.lastYear': 'Ostatni Rok',
    'reports.period.allTime': 'Cały Czas',
    'reports.period.custom': 'Zakres Niestandardowy',
};
